import { Accordion, AccordionValue, Alert } from '@mantine/core';
import { observer } from 'mobx-react-lite';
import * as React from 'react';

import Loader from '@/components/ui/Loader';
import { useSidebarNoteStore } from '@/stores/local/sidebar/SidebarNoteStore';

import Actions from '../Actions';
import FollowUpItem from '../FollowUpItem';

import { FOLLOW_UP_ACCORDION_ITEMS } from './config';
import { FollowUpAccordionKeys } from './types';

import s from './FollowUpList.module.scss';

const FollowUpList: React.FC = () => {
  const {
    followUp: { activeItems, meta, active, closed },
  } = useSidebarNoteStore();

  const handlerOnChange = React.useCallback(
    (value: AccordionValue<true>) => {
      activeItems.setKeys((value ?? []) as FollowUpAccordionKeys[]);
    },
    [activeItems],
  );

  if (meta.isError) {
    return (
      <Alert className={s.root__alert} ml="lg" mr="lg" color="red">
        Не удалось загрузить follow-up
      </Alert>
    );
  }

  if (!meta.isStaleLoaded) {
    return <Loader gap={0} fullHeight type="dots" size="md" text="Ищу follow-up..." />;
  }

  if (active.isEmpty && closed.isEmpty) {
    return (
      <Alert className={s.root__alert} ml="lg" mr="lg">
        Нет ни одного follow-up
      </Alert>
    );
  }

  return (
    <Accordion
      classNames={{
        root: s.root,
        control: s.root__control,
        content: s.root__content,
        label: s.root__label,
        chevron: s.root__chevron,
        item: s['root__accordion-item'],
      }}
      value={activeItems.keys}
      defaultValue={activeItems.keys}
      onChange={handlerOnChange}
      variant="filled"
      chevronPosition="left"
      multiple
      transitionDuration={300}
    >
      {FOLLOW_UP_ACCORDION_ITEMS.map(({ key, value }) => {
        const items = key === FollowUpAccordionKeys.active ? active.items : closed.items;

        return (
          <Accordion.Item key={key} value={key}>
            <Accordion.Control>{value}</Accordion.Control>
            <Accordion.Panel c="inherit">
              {items.length > 0 ? (
                items.map((item) => (
                  <FollowUpItem
                    className={s.root__item}
                    key={item.id}
                    model={item}
                    actionSlot={<Actions model={item} />}
                  />
                ))
              ) : (
                <Alert ml="lg" mr="lg" mt={0}>
                  {key === FollowUpAccordionKeys.active ? 'Нет открытых follow-up' : 'Нет закрытых follow-up'}
                </Alert>
              )}
            </Accordion.Panel>
          </Accordion.Item>
        );
      })}
    </Accordion>
  );
};

export default observer(FollowUpList);
